// extracted by mini-css-extract-plugin
export default {"asterisk":"mvlHM8","planItem":"OQo0m9","errorTooltip":"hM6ULe","errorMessageContainer":"ssieeF","errorIcon":"Ey1SqP"};